import { palette } from '@livable/saas-react-components';
const MuiStep = {
  styleOverrides: {
    root: {
      '&:last-child .MuiStepConnector-root': {
        right: '50%'
      },
      '& .MuiStepConnector-root': {
        left: '-50%',
        right: '0',
        '& .MuiStepConnector-line': {
          borderColor: palette.shades[500]
        },
        '&.Mui-active .MuiStepConnector-line': {
          borderColor: palette.primary.dark
        },
        '&.Mui-completed .MuiStepConnector-line': {
          borderColor: palette.primary.dark
        }
      },
      '& .MuiStepLabel-iconContainer': {
        backgroundColor: palette.shades[200],
        zIndex: '10'
      },
      '& .MuiStepLabel-iconContainer path': {
        fill: palette.shades[600]
      },
      '& .MuiStepLabel-root': {
        '&:hover': {
          cursor: 'pointer'
        }
      },
      '& .MuiStepLabel-labelContainer': {
        padding: '0 4px'
      },
      '& .MuiStepLabel-label': {
        color: palette.shades[700],
        fontFamily: palette.fontFamilies.poppins,
        fontSize: '13px',
        lineHeight: '16px',
        '& .MuiStepLabel-alternativeLabel': {
          marginTop: '10px'
        },
        '& .Mui-active': {
          color: palette.shades[800]
        }
      },
      '&.Mui-completed': {
        '& .MuiStepLabel-iconContainer path': {
          fill: palette.primary.dark
        }
      }
    }
  }
};
export default MuiStep;